import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatProgressBar} from '@angular/material/progress-bar';

import {DrawingModel, GameModel} from 'shared/models';

@Component({
  selector: 'progress-bar-ui',
  standalone: true,
  imports: [CommonModule, MatProgressBar],
  templateUrl: './progress-bar-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarUi {
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();

  protected playedGames: Signal<GameModel[]> = computed((): GameModel[] => {
    const games: GameModel[] = this.games();
    return games.filter((model: GameModel): boolean => {
      // @TODO: usar enum
      return model.status === 'finished';
    });
  });
}
